package com.exura.pages.test

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import com.exura.components.loading.Loader
import com.exura.components.layouts.NavigableLayoutScope
import com.exura.features.plandefinition.demosets.neuca.AlcoholReductionPlan
import com.exura.features.plandefinition.demosets.neuca.SmokingCessationPlan
import com.exura.features.plandefinition.demosets.neuca.SupplementationMale50Plan
import com.exura.features.plandefinition.demosets.neuca.YearlyLongevityProgram
import com.exura.features.plandefinition.demosets.usaSets.US_Premier_Surgical_Prep
import com.exura.features.plandefinition.usecase.CreateTreatmentPlanUseCase
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import com.exura.features.publicplans.domain.usecase.CreateNewPublicPlanUseCase
import com.exura.features.publicplans.domain.usecase.ListPublicPlansUseCase
import com.exura.features.publicplans.domain.usecase.RefreshPlanStatisticsUseCase
import com.exura.util.injectAndRemember
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext

@Page("/test")
@Layout(".components.layouts.NavigableLayout")
@Composable
fun NavigableLayoutScope.MyPage() {
    val pageContext = rememberPageContext()
    val coroutineScope = rememberCoroutineScope()
    val createTreatmentPlanUseCase = injectAndRemember<CreateTreatmentPlanUseCase>()
    val listUsecase = injectAndRemember<ListPublicPlansUseCase>()
    val createUsecase = injectAndRemember<CreateNewPublicPlanUseCase>()
    val refreshUseCase = injectAndRemember<RefreshPlanStatisticsUseCase>()
    val repo = injectAndRemember<ProviderPublicPlanRepository>()

//    var refreshKey

    LaunchedEffect(Unit) {
        val v = createTreatmentPlanUseCase(YearlyLongevityProgram).getOrNull()
//
//        createTreatmentPlanUseCase(SmokingCessationPlan).getOrNull()
//        createTreatmentPlanUseCase(AlcoholReductionPlan).getOrNull()
//        createTreatmentPlanUseCase(SupplementationMale50Plan).getOrNull()

    }

}
